(function CalendarIndex($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('CalendarSearchIndex/index', function onload() {
			// Calendar click
			$('.calendar-full-day').click(function calendarFullDayClick() {
				if (!$(this).hasClass('inactive')) {
					document.location = Adzuki.base_uri + '/CalendarSearchIndex/view/' + $(this).data('daydate');
				}
			});
		});
	});

	// functions here

}(jQuery, window.Adzuki || {}));